import {isEmpty} from "lodash";
import {trackKlaviyoEvent, trackViewedItemAttrs, withKlaviyo} from "../ExternalServices/Klaviyo/KlaviyoHelpers";

export function sendKlaviyoPageEvents() {
  const eventList = getEmbeddedEvents();
  if (isEmpty(eventList)) return false;

  for (let e of eventList) {
    trackKlaviyoEvent(e.type, e.data);
  }

  // If there is a ViewedProduct event in the list, send a trackViewedItem with
  // slightly different data.
  let productEvent = eventList.find(e => e.type == "Viewed Product");
  if (productEvent) {
    let attrs = trackViewedItemAttrs(productEvent.data);
    console.log(`sending trackViewedItem: ${JSON.stringify(attrs, null, 2)}`)
    //withKlaviyo( k => k.push(["trackViewedItem", attrs]) );
    withKlaviyo(k => k.trackViewedItem(attrs));
    // FIXME KLAVIYO - not sending trackViewedItem
    window.ITEM = attrs;
  }
}

/**
 * Look for klaviyo-page-events embedded in page, set in footer_scripts.html
 *
 * @returns {any}
 */
function getEmbeddedEvents() {
  let script = document.getElementById('klaviyo-page-events');
  if (script) {
    return JSON.parse(script.textContent);
  }
}

